import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PATH_LSL_BACKOFFICE } from '../../constants';
import { FdmPrecheckWizardService } from './fdm-precheck-wizard.service';

@Component({
  selector: 'ls-fdm-precheck-wizard-overlay',
  templateUrl: './fdm-precheck-wizard-overlay.component.html',
  styleUrls: ['./fdm-precheck-wizard-overlay.component.scss']
})
export class FdmPrecheckWizardOverlayComponent implements OnInit, OnDestroy {
  public isOpen = false;
  public iframeSrc: SafeResourceUrl;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private wizardService: FdmPrecheckWizardService,
    private sanitizer: DomSanitizer
  ) {}

  public ngOnInit(): void {
    this.iframeSrc = this.buildIframeUrl();

    this.wizardService.isOpen$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isOpen: boolean) => {
        this.isOpen = isOpen;
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  @HostListener('window:message', ['$event'])
  public onPostMessage(event: MessageEvent): void {
    if (!this.isOpen) {
      return;
    }

    const data: any = this.parseMessageData(event.data);
    if (!data || !data.messageType) {
      return;
    }

    if (data.messageType === 'completeWizard') {
      this.wizardService.close('completed');
    } else if (data.messageType === 'closeWizard') {
      this.wizardService.close('cancelled');
    }
  }

  private buildIframeUrl(): SafeResourceUrl {
    const url: string = PATH_LSL_BACKOFFICE + 'blackbox_v2_migration.html';
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  private parseMessageData(data: any): any {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    return data;
  }
}
